import React, { useState } from 'react';
import { contacts, content } from '../../content';
import {
  ArrowRightIcon,
  CheckIcon,
  MailIcon,
  TelegramIcon,
  socialIcons,
} from '../Icon';
import '../../styles/Sections.css';

const { contact, socials } = content;

const ContactSection = () => {
  const [copied, setCopied] = useState(false);

  /**
   * Clipboard access is denied outside a secure context and in some in-app
   * browsers, so a hidden textarea and `execCommand` stand behind it — the
   * address is the only way to reach this inbox from the page, and a click
   * that silently does nothing is worse than an old API.
   */
  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(contacts.email);
    } catch {
      const field = document.createElement('textarea');
      field.value = contacts.email;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy');
      } catch {
        /* nothing left to try — the address is on screen to be read */
      }
      document.body.removeChild(field);
    }

    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="section">
      <section className="panel contact-hero">
        <div className="contact-hero__body">
          <h3 className="contact-hero__title">{contact.heroTitle}</h3>
          <p className="contact-hero__text">{contact.heroText}</p>
        </div>

        {/* Telegram leads: it is the channel this audience actually replies in,
            and it works on a phone where a mailto link often does not. */}
        <div className="contact-hero__actions">
          <a
            className="btn btn--primary"
            href={contacts.telegram}
            target="_blank"
            rel="noreferrer"
          >
            <TelegramIcon size={16} />
            {contact.telegram}
          </a>
          <button
            type="button"
            className="btn btn--ghost"
            onClick={copyEmail}
            title={contact.copyHint}
            aria-label={`${contacts.email} — ${contact.copyHint}`}
            aria-live="polite"
          >
            {copied ? <CheckIcon size={16} /> : <MailIcon size={16} />}
            {copied ? contact.copied : contacts.email}
          </button>
        </div>
      </section>

      <div className="contact-grid">
        {socials.map(({ id, label, href, handle }) => {
          const Icon = socialIcons[id];

          return (
            <a
              key={id}
              className="contact-card"
              href={href}
              target="_blank"
              rel="noreferrer"
            >
              <Icon size={22} className="contact-card__icon" />
              <span className="contact-card__body">
                <span className="contact-card__label">{label}</span>
                <span className="contact-card__handle">{handle}</span>
              </span>
              <ArrowRightIcon size={16} className="contact-card__arrow" />
            </a>
          );
        })}
      </div>

      <section className="panel">
        <header className="panel__head">
          <h3 className="panel__title">{contact.processTitle}</h3>
          <p className="panel__caption">{contact.processCaption}</p>
        </header>

        <ol className="steps">
          {contact.process.map((step) => (
            <li key={step.number} className="step">
              <span className="step__number">{step.number}</span>
              <h4 className="step__title">{step.title}</h4>
              <p className="step__text">{step.body}</p>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
};

export default ContactSection;
